import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { RootState } from "../config/Store";
import { AnyAction } from "redux";

interface ReduxData {
  type: string;
  value: any;
}

export const setDataInRedux =
  (data: ReduxData): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (
    dispatch: ThunkDispatch<RootState, unknown, AnyAction>
  ): Promise<void> => {
    dispatch({
      type: data.type,
      payload: data.value,
    });
  };

export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";
export const SYSTEMATIC_PLAN_TAB = "SYSTEMATIC_PLAN_TAB";
export const ADMIN_INVOICE_TAB = "ADMIN_INVOICE_TAB";
export const ADMIN_ASSIGN_TASK_TAB = "ADMIN_ASSIGN_TASK_TAB";
export const ADMIN_MY_TASK_TAB = "ADMIN_MY_TASK_TAB";
export const USER_PROFILE_ID = "USER_PROFILE_ID";
export const ADVICE_LOG_BOOK = "ADVICE_LOG_BOOK";
export const SHARE_TAB = "SHARE_TAB";
export const SENT_FOR_REVIEW_TAB = "SENT_FOR_REVIEW_TAB";
export const MANAGER_TAB = "MANAGER_TAB";
export const COMPANY_MASTER_TAB = "COMPANY_MASTER_TAB";
export const PAGINATION = "PAGINATION";
export const ADMIN_TASK_TAB = "ADMIN_TASK_TAB";
export const REPORT_TYPE = "REPORT_TYPE";
export const SLAB_TAB = "SLAB_TAB";
export const AGREEMENT_TAB = "AGREEMENT_TAB";

